/* global spapi swellDef Referrals VipSection swellAPI toggleReferralSection RedemptionDiscount CampaignGrid ProductRedemptions snCart */
const referral = new Referrals(swellDef.referralForms, swellDef.referralShareLinks);
const vipContainer = new VipSection(swellDef.vipTiers);

if (window.location.href.includes('account')) {
	window.onbeforeunload = function () {
		window.scrollTo(0, 0);
	}
}

$(window).on('load', () => {
	(() => {
		// console.log('on load');
		// $(document).on('ready', () => {
			setTimeout(function () {
				$('.jconfirm-buttons .btn:contains(Keep Shopping)').replaceWith('<button type="button" class="btn btn-default" onclick="window.location.reload();">Continueq</button>');
				$('.jconfirm-buttons .btn:contains(View Cart)').replaceWith('<button type="button" class="btn btn-default" href="javascript:void(0)" data-toggle="modal" data-target="#cart-drawer">View Cart</button>');
			}, 3000);

			$('#cart-drawer').on('shown.bs.modal', function () {
				$('.jconfirm.jconfirm-open').remove();
			});

			$(document).on('swell:initialized', () => {
				// console.log('swell:initialized');
			});

			$(document).on('swell:setup', () => {
				// console.log('swell:setup');
				referral.showReferralForm();
				vipContainer.renderVipTiers(swellAPI.getVipTiers());
				new RedemptionDiscount(swellAPI.getActiveRedemptionOptions()).renderRedemptionList();
				new CampaignGrid(swellAPI.getActiveCampaigns()).renderCampaigns();
				new ProductRedemptions(swellAPI.getActiveRedemptionOptions(), swellDef.redemptionsExclusions,
					swellAPI.getCustomerDetails().pointsBalance).renderRedemptionOptions();
				referral.revealActiveForm(swellAPI.getCustomerDetails(),
					swellDef.referralForms.newUserForm.formType,
					swellDef.referralForms.existingUserForm.formType);
				referral.renderReferredEmails(swellAPI.getCustomerDetails().referrals);
				vipContainer.renderVipStatus(swellAPI.getCustomerDetails().vipTier, swellAPI.getVipTiers(),
					swellAPI.getCustomerDetails().email);
				$('section.swell-rewards-vip, section.swell-product-redemption, section.swell-rewards-campaign').css('display', 'block');
				$('section.swell-rewards-redemption-discounts, section.swell-referrals-section').css('display', 'flex');
				$('.page-loading-icon').css('display', 'none');

				$('.swell-copy-button').click(function () {
					$(this).text('COPIED!');
				});
				$('section.swell-referrals-section').css('display', 'flex');
				toggleReferralSection();
				spapi.initialize();
			});
		// });
	}).call(this);
});

function addXMLRequestCallback(callback) {
	let oldSend;
	if (XMLHttpRequest.callbacks) {
		XMLHttpRequest.callbacks.push(callback);
	} else {
		XMLHttpRequest.callbacks = [callback];
		oldSend = XMLHttpRequest.prototype.send;
		XMLHttpRequest.prototype.send = function () {
			for (let i = 0; i < XMLHttpRequest.callbacks.length; i += 1) {
				XMLHttpRequest.callbacks[i](this);
			}
			// eslint-disable-next-line prefer-rest-params
			oldSend.apply(this, arguments);
		};
	}
}

addXMLRequestCallback(function (xhr) {
	if (xhr._url) {
		if (xhr._url.indexOf('/cart/add.js') !== -1 && xhr._method === 'POST') {
			// eslint-disable-next-line no-param-reassign
			xhr.onloadend = function () {
				const interval = setInterval(function () {
					const button = $('.jconfirm-buttons .btn:contains(Keep Shopping)');
					if (button.length) {
						clearInterval(interval);
						button.replaceWith('<button type="button" class="btn btn-default" onclick="window.location.reload();">Continue</button>');
						$('.jconfirm-buttons .btn:contains(View Cart)').replaceWith('<button type="button" class="btn btn-default" href="javascript:void(0)" data-toggle="modal" data-target="#cart-drawer">View Cart</button>');
						$('.jconfirm-buttons').addClass('completed');
						snCart.getCart();
					}
				}, 200);
			};
		}

		if (xhr._url.indexOf('/cart') !== -1 && xhr._method === 'POST') {
			// need to waiting until origin request done then update the content
			setTimeout(function () {
				$('.swell-product-redemption-carousel').html('');
				new ProductRedemptions(swellAPI.getActiveRedemptionOptions(), swellDef.redemptionsExclusions,
					swellAPI.getCustomerDetails().pointsBalance).renderRedemptionOptions();
				spapi.initialize();
			}, 1500);
		}
	}
});
